import { Toaster as Sonner, type ToasterProps } from 'sonner';
import { Icon } from './icon';

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      position="top-right"
      icons={{
        success: <Icon name="check_circle" className="icon-base text-success-500" />,
        info: <Icon name="info" className="icon-base text-white" />,
        warning: <Icon name="warning" className="icon-base text-warning-500" />,
        error: <Icon name="error" className="icon-base text-error-500" />,
        loading: <Icon name="progress_activity" className="icon-base text-white animate-spin" />,
      }}
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:shadow-lg border border-[var(--border-default)] bg-surface text-text-primary',
          title: 'text-text-primary',
          description: 'group-[.toast]:text-text-secondary',
          actionButton: 'group-[.toast]:bg-brand-blue-500 group-[.toast]:text-base-white',
          cancelButton: 'group-[.toast]:bg-neutral-100 group-[.toast]:text-text-primary',
          success: '!bg-success-100 !border-success-500 !text-success-900',
          error: '!bg-error-100 !border-error-500 !text-error-900',
          warning: '!bg-warning-100 !border-warning-500 !text-warning-900',
          info: '!bg-brand-blue-600 !border-brand-blue-600 !text-white',
          loading: '!bg-brand-blue-50 !border-brand-blue-500 !text-brand-blue-900',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
